import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {QueryProvider} from '@shared/queries/query-provider';
import {TaskManagerService} from "../../../task-manager/services/task-manager.service";

@Component({
    standalone: false,
    selector: 'particle-archive-unarchive-dialog',
  templateUrl: './archive-unarchive-dialog.component.html',
  styleUrls: ['./archive-unarchive-dialog.component.scss']
})
export class ArchiveUnarchiveDialogComponent implements OnInit, OnDestroy, IDialogView {
  data: DialogModel;
  dialogRef: any;
  event : any;
  message: string;
  question: string;
  taskId: string;
  isExistTask: boolean;
  taskDisplayId: string;
  private unsubscribe$ = new Subject<void>();
  constructor(private taskManagerService: TaskManagerService){

  }

  ngOnInit() {
    this.event = this.data.input ;
    this.message = "You can archive this filing record if it is deemed 'completed' or if you have replaced it with a more recent filing record. Archived filing records are still available to view, and can be unarchived if required.";
    this.question = "Are you sure you want to archive this filing record?" ;
    console.log('All Case Data: ', this.data.input);
    console.log('taskId: ', this.data.input.item.cells['DAC6FilingStatus'].value.taskId) ;
    console.log('taskDisplayId', this.data.input.item.cells['DAC6FilingStatus'].value.taskDisplayId) ;
    this.taskId = this.data.input.item.cells['DAC6FilingStatus'].value.taskId;
    this.taskDisplayId = this.data.input.item.cells['DAC6FilingStatus'].value.taskDisplayId;
    this.isExistTask = true;
    if( this.event.item.cells['DAC6FilingStatus'].value.taskId == null ) this.isExistTask = false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    return true;
  }

  showTask() {
    this.event = this.data.input ;
    this.taskManagerService.openTaskByTaskId(this.event.item.cells['DAC6FilingStatus'].value.taskId, 'COMPANY').subscribe(state => {

    });
  }

}
